// localStorage that never throws (private mode, blocked storage).
export const store = {
  get(key: string): string | null { try { return localStorage.getItem(key); } catch { return null; } },
  set(key: string, value: string) { try { localStorage.setItem(key, value); } catch { /* ignore */ } },
  remove(key: string) { try { localStorage.removeItem(key); } catch { /* ignore */ } },
};
